import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 4H9V3a1 1 0 00-2 0v1H6a3 3 0 00-3 3v12a3 3 0 003 3h6.5a1 1 0 100-2H6a1 1 0 01-1-1v-8h14v2a1 1 0 102 0V7a3 3 0 00-3-3h-1V3a1 1 0 10-2 0v1zM5 7a1 1 0 011-1h12a1 1 0 011 1v2H5V7z",
      fill: "#292933"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.166 20.556l-1.761-1.76.6-.149a1.136 1.136 0 00.116-2.169l-5.09-1.908h-.004a1.137 1.137 0 00-1.455 1.465l1.91 5.089.002.005a1.136 1.136 0 002.16-.125l.149-.599 1.762 1.762a1.14 1.14 0 001.611-1.61z",
      fill: "#292933"
    }
  )
);
export {
  l as default
};
